import HttpService from "./httpService";

export const getHelpText = (size, offset, sortBy, sortDir) => {
  const uri = `/admin/helptext?size=${size}&offset=${offset}&sortDir=${sortDir}&sortBy=${sortBy}`;
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const updateHelpText = body => {
  const uri = "/admin/helptext";
  return async () => {
    return HttpService.putRequest(uri, body);
  };
};

export const getFiscalYear = () => {
  const uri = `/admin/fiscalyear`;
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const updateFiscalYear = year => {
  const uri = `/admin/fiscalyear`;
  return async () => {
    return HttpService.putRequest(uri, year);
  };
};

export const getMailingAddress = () => {
  const uri = `/admin/mailingaddress`;
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const updateMailingAddress = mailingAddress => {
  const uri = `/admin/mailingaddress`;
  return async () => {
    return HttpService.putRequest(uri, mailingAddress);
  };
};

export const getChapterRanges = () => {
  const uri = `/admin/chapterranges`;
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const updateChapterRange = body => {
  const uri = `/admin/chapterrange`;
  return async () => {
    return HttpService.putRequest(uri, body);
  };
};

export const updateChapterRanges = body => {
  const uri = `/admin/chapterranges`;
  return async () => {
    return HttpService.putRequest(uri, body);
  };
};

export const getMemberCounts = (
  size,
  offset,
  chapterId,
  year,
  sortDir,
  sortBy
) => {
  let uri = `/admin/membercounts?size=${size}&offset=${offset}&sortDir=${
    sortDir === "asc" ? 2 : 1
  }&sortBy=${sortBy}`;
  if (chapterId >= 0) {
    uri = `${uri}&chapterId=${chapterId}`;
  }
  if (year >= 0) {
    uri = `${uri}&year=${year}`;
  }
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const createMemberCount = body => {
  const uri = `/admin/membercount`;
  return async () => {
    return HttpService.postRequest(uri, body);
  };
};

export const updateMemberCount = body => {
  const uri = `/admin/membercount`;
  return async () => {
    return HttpService.putRequest(uri, body);
  };
};

export const getChapterList = () => {
  const uri = `/chapters/list`;
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const getChapter = id => {
  const uri = `/chapter/${id}`;
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const getChapterBudgets = year => {
  const uri = `/admin/chapterbudgets?year=${year}`;
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const getChapterBudget = id => {
  return async () => {
    return HttpService.getRequest(`/admin/chapterbudget/${id}`);
  };
};

export const createChapterBudget = body => {
  const uri = `/admin/chapterbudget`;
  return async () => {
    return HttpService.postRequest(uri, body);
  };
};

export const updateChapterBudget = body => {
  const uri = `/admin/chapterbudget`;
  return async () => {
    return HttpService.putRequest(uri, body);
  };
};

export const updateChapterBudgetFile = (id, body) => {
  const uri = `/admin/chapterbudget/${id}/upload`;
  return async () => {
    return HttpService.postRequest(uri, body, {
      "Content-Type": "multipart/form-data"
    });
  };
};

export const downloadChapterBudgetFile = (id, filename) => {
  const uri = `/admin/download/${id}/${filename}`;
  return async () => {
    return HttpService.getRequestWithHeader(uri, {
      responseType: "blob"
    });
  };
};

export const getChapterAnalysisReports = (year, chapterid) => {
  let uri = `/admin/chapteranalysisreports?year=${year}&chapterid=${chapterid}`;
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const getChapterFinancials = year => {
  let uri = `/admin/chapterfinancials?year=${year}`;
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const getChapterFinancialByYear = (year, id) => {
  let uri = `/admin/chapterfinancials?chapterId=${id}&year=${year}`;

  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const getChapterFinancial = id => {
  const uri = `/admin/chapterfinancial/${id}`;
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const submitChapterFinancial = (id, notes) => {
  const uri = `/admin/chapterfinancial/${id}/submit?notes=${notes}`;
  return async () => {
    return HttpService.putRequest(uri);
  };
};

export const getReportItemTypes = () => {
  const uri = `/admin/reportitemtypes`;
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const getReportItemSubTypes = () => {
  const uri = `/admin/reportitemsubtypes`;
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const updateReportItemNotes = (id, body) => {
  const uri = `/admin/chapterfinancial/${id}/notes`;
  return async () => {
    return HttpService.putRequest(uri, body);
  };
};

export const createReportItemNotes = (id, year, body) => {
  const uri = `/admin/chapterfinancial/notes?chapterId=${id}&year=${year}`;
  return async () => {
    return HttpService.putRequest(uri, body);
  };
};

export const getChapterFinancialsDefaults = () => {
  const uri = `/chapter/chapterfinancials/defaults`;
  return async () => {
    return HttpService.getRequest(uri);
  };
};

export const getChapterSummaryReport = id => {
  const uri = `/admin/reports/chaptersummary/${id}`;
  return async () => {
    return HttpService.getRequest(uri, { responseType: "blob" });
  };
};

export const getGlobalAnalysisReport = (type, year) => {
  const uri = `/admin/reports/globalanalysis/${type}/${year}`;
  return async () => {
    return HttpService.getRequest(uri, { responseType: "blob" });
  };
};

export const get990Report = (type, year) => {
  const uri = `/admin/reports/990/${type}/${year}`;
  return async () => {
    return HttpService.getRequest(uri, { responseType: "blob" });
  };
};

export const getFinancialReport = (status, year) => {
  const uri = `/admin/reports/financial/${status}/${year}`;
  return async () => {
    return HttpService.getRequest(uri, { responseType: "blob" });
  };
};

export const getMemberCountTemplate = () => {
  const uri = `/admin/reports/membercounttemplate`;
  return async () => {
    return HttpService.getRequest(uri, { responseType: "blob" });
  };
};

export const uploadMemberCounts = body => {
  const uri = `/admin/reports/membercountupload`;
  return async () => {
    return HttpService.postRequest(uri, body);
  };
};

export const getYearToYearReport = id => {
  const uri = `/admin/reports/yeartoyear/${id}`;
  return async () => {
    return HttpService.getRequest(uri, { responseType: "blob" });
  };
};

export const getComparativeReport = id => {
  const uri = `/admin/reports/comparative/${id}`;
  return async () => {
    return HttpService.getRequest(uri, { responseType: "blob" });
  };
};

export const createReportItem = body => {
  const uri = `/admin/chapterfinancial/reportitem`;
  return async () => {
    return HttpService.postRequest(uri, body);
  };
};

export const updateReportItem = (id, body) => {
  const uri = `/admin/chapterfinancial/reportitem`;
  return async () => {
    return HttpService.putRequest(uri, {
      ...body,
      id
    });
  };
};

export const removeReportItem = id => {
  const uri = `/admin/chapterfinancial/reportitem/${id}`;
  return async () => {
    return HttpService.deleteRequest(uri);
  };
};

export const updateReportItems = body => {
  const uri = `/admin/chapterfinancial/reportitems`;
  return async () => {
    return HttpService.postRequest(uri, body);
  };
};

export const updateReportItemsPut = body => {
  const uri = `/admin/chapterfinancial/reportitems`;
  return async () => {
    return HttpService.putRequest(uri, body);
  };
};

export const initialReportItems = body => {
  const uri = `/admin/chapterfinancial/initialreportitems`;
  return async () => {
    return HttpService.postRequest(uri, body);
  };
};

export const updateReportW2 = body => {
  const uri = `/admin/chapterfinancial/reportw21099`;
  return async () => {
    return HttpService.putRequest(uri, body);
  };
};

export const updateVotingCount = body => {
  const uri = `/admin/chapterfinancial/votingcount`;
  return async () => {
    return HttpService.putRequest(uri, body);
  };
};

export const createFinancialAccount = body => {
  const uri = `/admin/chapterfinancial/financialaccount`;
  return async () => {
    return HttpService.postRequest(uri, body);
  };
};

export const updateFinancialAccount = body => {
  const uri = `/admin/chapterfinancial/financialaccount`;
  return async () => {
    return HttpService.putRequest(uri, body);
  };
};

export const removeFinancialAccount = id => {
  const uri = `/admin/chapterfinancial/financialaccount/${id}`;
  return async () => {
    return HttpService.deleteRequest(uri);
  };
};

export const acceptChapterFinancial = (id, body) => {
  const uri = `/admin/chapterfinancial/${id}/accept`;
  return async () => {
    return HttpService.putRequest(uri, {
      Value: body
    });
  };
};

export const rejectChapterFinancial = (id, body) => {
  const uri = `/admin/chapterfinancial/${id}/reject`;
  return async () => {
    return HttpService.putRequest(uri, {
      Value: body
    });
  };
};
